import React, { useEffect, useReducer } from "react";
import {
  ContractSection,
  FinancialSection,
  OtherDetailsSection,
  CommissionSection,
} from "./Utilities";
import { TrackEventService } from "../../../../../../Helper/mixpanelHelper";

export const AgreementEssentialsTab = (props) => {
  //change this from useeffect to next handler
  // useEffect(() => {
  //   onSelectedChanged(prevState => ({
  //     ...prevState,
  //     ...localSelected,
  //   }))
  // }, [localSelected]);

  // useEffect(() => {
  //   //todo:: this should be filled on next button clicked
  //   //split selected to 2 props : 2 tabs names
  //   onse({id: 'edit' , value: selected})
  // }, [selected]);
  useEffect(() => {
    //Traking Event
    TrackEventService(
      "Leasing_journey_Transaction_Execution_Lease_Agreement_Clicked",
      { page_name: "Leasing Journey", screen: "Transaction_Execution" }
    );
  }, []);

  useEffect(() => {
    //Traking Event
    TrackEventService(
      "Leasing_journey_Unit_Reservation_Reservation_Details_Clicked",
      { page_name: "Unit Reservation", screen: "Transaction_Execution" }
    );
  }, []);

  return (
    <div className="w-75">
      <FinancialSection {...props} />
      <ContractSection {...props} />
      <OtherDetailsSection {...props} />
      <CommissionSection {...props} />
    </div>
  );
};

